import React from "react";

import usePaymentSummaryData from "@Modules/eventPage/components/PaymentSummary/utils/usePaymentSummaryData";
import { SELECTORS } from "@Utils/constants/selectors";
import { useData } from "@Utils/hooks/data";
import { useSelector } from "react-redux";
import BillSummary from "./components/BillSummary/BillSummary";
import ExpandedBill from "./components/ExpandedBill/ExpandedBill";

// TODO @mayank: get backdrop + click functionality implemented in mobile render
/**
 * TODO @ishtiaq:
 * 1. need to refactor styles for this component
 * 2. need its children components to be refactored as well
 */

const PaymentSummary = ({
    showExpandedBill,
}: {
    showExpandedBill?: boolean;
}) => {
    const props = useSelector(SELECTORS.paymentSummaryProps);
    const { isMobile, isOpenedAsEventModal } = props;

    const { setData: setHideContactWidget } = useData<boolean>(
        "hideContactWidget",
        false
    );

    const onToggleIsPaymentSummaryExpanded = (
        isPaymentSummaryExpanded: boolean
    ) => {
        if (!isOpenedAsEventModal && isMobile) {
            setHideContactWidget(isMobile && isPaymentSummaryExpanded);
        }
    };

    const {
        hideComponent,
        expandedBillProps,
        billSummaryProps,
        isPaymentSummaryExpanded,
    } = usePaymentSummaryData({
        ...props,
        onToggleIsPaymentSummaryExpanded,
        showExpandedBill,
    });

    if (hideComponent) return null;

    // Expanded Payment Details View
    if (isPaymentSummaryExpanded) {
        return <ExpandedBill {...expandedBillProps} />;
    }

    // Collapsed Payment Details View
    return <BillSummary isMobile={isMobile} {...billSummaryProps} />;
};
export default PaymentSummary;

PaymentSummary.defaultProps = {
    showExpandedBill: false,
};
